import { render, staticRenderFns } from "./ksshop.vue?vue&type=template&id=b1aa835a&scoped=true&"
import script from "./ksshop.vue?vue&type=script&lang=js&"
export * from "./ksshop.vue?vue&type=script&lang=js&"
import style0 from "./ksshop.vue?vue&type=style&index=0&id=b1aa835a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa835a",
  null
  
)

export default component.exports